import { useMutation } from 'react-query';
import { partnerUserService } from 'hq/services';

export const useDeletePartnerUser = () => {
  const mutationFn = async (userId: string) => await partnerUserService.archiveUser(userId);

  return useMutation(mutationFn);
};
